import type { HomeworkHistory as HomeworkHistoryResponse } from '@mathflat/domain/StudentHistory'
import { tJosa } from '@mathflat/shared/i18n/tJosa'
import { makeAutoObservable } from 'mobx'

import type { LearningProgress } from '../ProgressAndPage'
import { HomeworkHistoryDetailColl } from './HomeworkHistoryDetailColl'

// 출제 ID
type AssignId = number

export type HomeworkHistoryData = Exclude<HomeworkHistory['historyDataList'], undefined>[number]

export class HomeworkHistory {
  title: string
  subtitle?: string
  bookType: LearningProgress['bookType']
  bookId: number
  round?: number
  autoScorable: boolean
  elements: Set<AssignId>
  components?: HomeworkHistoryDetailColl

  constructor(params: HomeworkHistoryResponse) {
    makeAutoObservable(this)
    this.title = params.title
    this.subtitle = params.subtitle ?? undefined
    this.elements = new Set(params.elements)
    this.bookType = params.bookType
    this.bookId = params.bookId
    this.autoScorable = !!params.autoScorable

    if (params.round) {
      this.round = params.round
    }
    if (params.components) {
      this.components = new HomeworkHistoryDetailColl(params.components)
    }
  }

  get elementsArr() {
    return [...this.elements.values()]
  }

  get koBookType() {
    switch (this.bookType) {
      case 'WORKBOOK':
        return '교재'
      case 'WORKSHEET':
        return '학습지'
      case 'CAS':
        return tJosa('반응형평가')
    }
  }

  get historyDataList() {
    if (!this.components) return

    const data = this.components.map.toArr.map((data) => ({
      ...data,
      koBookType: this.koBookType,
      title: this.title,
      uiTitle: this.uiTitle,
      autoScorable: this.autoScorable,
      clientId: this.clientId,
    }))

    return data
  }

  // 그룹의 고유 id
  get clientId() {
    switch (this.bookType) {
      case 'WORKBOOK':
        return `${this.bookId}-${this.round}`
      case 'WORKSHEET':
      case 'CAS':
        return this.bookId
    }
  }

  get uiTitle() {
    return `${this.title} ${this.subtitle ? `- ${this.subtitle}` : ''}`
  }
}
